import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import Tabs from 'srcReact/components/common2/Tabs'
import { useTranslation } from 'react-i18next'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import GroupDashboard from './GroupDashboard'
import WorkplaceDashboard from './WorkplaceDashboard'
import { useDispatch, useSelector } from 'react-redux'
import { redirectToPage } from 'srcReact/helpers/history'
import { isWorkplaceManager } from 'srcReact/helpers/workplaceHelper'
import { dashboardActions } from './actions'

function Dashboard(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedTab, setSelectedTab] = useState('')
  const [groupId, setGroupId] = useState(0)
  const [workplaceId, setWorkplaceId] = useState(0)
  const {
    dashboardDetail: { data, header, loading }
  } = useSelector((state) => state)

  useEffect(() => {
    if (props?.match) {
      if (props?.match?.params?.group_id) {
        setSelectedTab('group')
        setGroupId(props.match.params.group_id)
      } else {
        setSelectedTab('workplace')
        setWorkplaceId(props.match.params.workplace_id)
      }
    }
  }, [props.match])
  const changeTab = (type) => {
    setSelectedTab(type)
    dispatch(dashboardActions.clearData())
    if (header?.header_tabs) {
      if (type === 'workplace') {
        redirectToPage(`/0/dashboard/workplace/${header.header_tabs.workplace_id}`)
      } else if (type === 'group') {
        redirectToPage(`/0/dashboard/group/${header.header_tabs.group_id}`)
      }
    }
  }
  return (
    <PageContainer
      pageClassName={styles.pageContainer}
      withSidebar={true}
      pageTitle={selectedTab === 'group' ? t('dashboard.titleGroup') : t('dashboard.titleWP')}
      withFooter={false}>
      <div className={styles.dashboardContainer}>
        {isWorkplaceManager() ? (
          <Tabs initialActive={selectedTab === 'group' ? 0 : 1} type='boxed' className={styles.tabs}>
            <div onClick={() => changeTab('group')} label={t('dashboard.titleGroup')}>
              <GroupDashboard type={selectedTab} groupId={groupId} />
            </div>
            <div onClick={() => changeTab('workplace')} label={t('dashboard.titleWP')}>
              <WorkplaceDashboard type={selectedTab} workplaceId={workplaceId} />
            </div>
          </Tabs>
        ) : (
          <GroupDashboard type='group' groupId={groupId} className={styles.groupDashboardWOTabs} />
        )}
      </div>
    </PageContainer>
  )
}

export default Dashboard
